__turbopack_context__.v({
  "activeDot": "homeslider-module__2oe_Ea__activeDot",
  "bannerContainer": "homeslider-module__2oe_Ea__bannerContainer",
  "contentOverlay": "homeslider-module__2oe_Ea__contentOverlay",
  "desktopImage": "homeslider-module__2oe_Ea__desktopImage",
  "dot": "homeslider-module__2oe_Ea__dot",
  "dotsContainer": "homeslider-module__2oe_Ea__dotsContainer",
  "heroBackground": "homeslider-module__2oe_Ea__heroBackground",
  "heroImage": "homeslider-module__2oe_Ea__heroImage",
  "mobileImage": "homeslider-module__2oe_Ea__mobileImage",
});
